module.exports = __webpack_public_path__ + "static/media/Workday_Step1a_Image3h.549c0371.jpg";